var _a;
import { createActions } from 'redux-actions';
export var getDepartments = (_a = createActions('GET_DEPARTMENTS', 'GET_DEPARTMENTS_COMPLETE'), _a.getDepartments), getDepartmentsComplete = _a.getDepartmentsComplete;
